import React from 'react';
import {ScrollView, View} from 'react-native';
import {ThemeProvider} from '@rneui/themed';
import {observer} from 'mobx-react';

import AccessYourCard from '../../../components/rewards/AccessYourCard';
import AddToWallet from '../../../components/rewards/AddToWallet';
import InStoreCode from '../../../components/rewards/InStoreCode';
import MemberCard from '../../../components/rewards/MemberCard';
import OptOutCTA from '../../../components/rewards/OptOutCTA';
import Text from '../../../components/themed/Text';
import ContentView from '../../../components/ui-controls/layout/ContentView';
import logoImg from '../../../images/brand/header-logo.png';
import {AppRoute} from '../../../models/AppRoute';
import {RouteNavigatorScreenProps} from '../../../models/navigationTypes';
import {useStores} from '../../../stores/use-stores';
import rewardsTheme from '../../../theme/rewardsTheme';
import RewardsListScreen from '../../articles/RewardsListScreen';

const AccountRewardsScreen = observer(
  ({
    navigation,
    route,
  }: RouteNavigatorScreenProps<
    AppRoute.REWARDS | AppRoute.ACCOUNT_REWARDS
  >) => {
    const {rewardsStore} = useStores();

    return (
      <ThemeProvider theme={rewardsTheme}>
        {rewardsStore.hasRewards ? (
          <AccountRewardsHasRewardsScreen
            route={route}
            navigation={navigation}
          />
        ) : (
          <RewardsListScreen navigation={navigation} route={route} />
        )}
      </ThemeProvider>
    );
  },
);

const AccountRewardsHasRewardsScreen = observer(
  ({
    navigation,
    route,
  }: RouteNavigatorScreenProps<
    AppRoute.REWARDS | AppRoute.ACCOUNT_REWARDS
  >) => {
    const {rewardsStore, userStore} = useStores();
    return (
      <ScrollView>
        <ContentView testID="account-rewards-has-rewards-screen">
          <Text variant="heading1">Your rewards card</Text>
          <Text variant="body2">
            Congrats, {userStore.firstName}! You are now a part of our rewards
            program! Show this barcode at checkout to collect awesome rewards!
          </Text>
          <View style={{gap: 8, marginTop: 24}}>
            <MemberCard
              logoImg={logoImg}
              cardNumber={rewardsStore.cardNumber}
              name={userStore.name}
            />
            <AddToWallet walletUrl={rewardsStore.walletUrl} />
          </View>
          <Text style={{fontWeight: 600, marginTop: 50}} variant="heading2">
            Your temporary rewards code
          </Text>
          <Text variant="body2" style={{marginTop: 8}}>
            Want to keep ahold of your phone? Give this code at checkout
            instead.
          </Text>
          <InStoreCode inStoreCode={rewardsStore.shortcode} />
          <View style={{height: 50}} />
          <AccessYourCard />
          <View style={{height: 50}} />
          <OptOutCTA
            onOptOut={() => {
              rewardsStore.optOut(userStore.phoneNumber, userStore.lastName);
              // TODO - handle if there was an API error
            }}
          />
          <View style={{height: 50}} />
        </ContentView>
      </ScrollView>
    );
  },
);

export default AccountRewardsScreen;
